module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.4fff33ac.woff";